module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_id02-59ea1bb9610b17ba85d3fc85132f5ebf.png";